import { createActions } from 'redux-actions';

export const roomsActions = createActions({
  CREATE_ROOM: (roomName, workerOptions) => ({ roomName, workerOptions }),
  CREATE_ROOM_SUCCESS: room => room,
  CREATE_ROOM_FAIL: [error => error, (...[, processedError]) => processedError],
}, { prefix: 'MT_COMMON_ROOMS' });
